import Vibrant = require('./browser')
import pipeline from './pipeline'

Vibrant.use(pipeline)

export = Vibrant
